import React from "react";
import Cleave from 'cleave.js/react';


const InputMask = ({handleChange, container, label, error, className, ...otherProps}) => (
    <div className={container ? (container.class + (error && error.text ? ' is-invalid' : '')) : (error && error.text ? ' is-invalid' : '')}>
        {
            label && label.text ?
                (
                    <label className={label.class ? label.class : `form-label`}>
                        <span>{label.text ? label.text : ''}</span>
                        {
                            label.require ?
                                <span>
                                    {label.requireText ? label.requireText : '*'}
                                </span>
                                : ''
                        }
                    </label>
                ) :
                null
        }
        <Cleave
            onChange={handleChange}
            className={(className ? className : "form-control mb-3") + (error && error.text ? ' is-invalid' : '')}
            {...otherProps}
        />

        {
            error && error.text ?
                <div className={error.class ? error.class : `invalid-feedback`}>
                    {error.text ? error.text : ''}
                </div>
                :
                null
        }
    </div>

);
export default InputMask;
